import * as React from "react";

export type ISelectContextValue = {
  isSimple: boolean;
  isMobile: boolean;
  open: boolean;
  handleOpenChange: (open: boolean) => void;
  selectedValues: string[];
  selectedValueSet: Set<string>;
  handleItemSelect: (value: string, label?: string) => void;
  removeValue: (value: string) => void;
  search: string;
  setSearch: (s: string) => void;
  searchable: boolean;
  creatable: boolean;
  multiple: boolean;
  placeholder?: string;
  label?: React.ReactNode;
  disabled?: boolean;
  registerItem: (value: string, label: string) => void;
  itemLabelsByValue: React.MutableRefObject<Map<string, string>>;
};

const defaultSelectContext: ISelectContextValue = {
  isSimple: false,
  isMobile: false,
  open: false,
  handleOpenChange: () => {},
  selectedValues: [],
  selectedValueSet: new Set(),
  handleItemSelect: () => {},
  removeValue: () => {},
  search: "",
  setSearch: () => {},
  searchable: false,
  creatable: false,
  multiple: false,
  registerItem: () => {},
  itemLabelsByValue: { current: new Map() },
};

export const SelectContext =
  React.createContext<ISelectContextValue>(defaultSelectContext);
